import { render, staticRenderFns } from "./new_user_info_add.vue?vue&type=template&id=457aadf5&scoped=true&lang=pug&"
import script from "./new_user_info_add.vue?vue&type=script&lang=js&"
export * from "./new_user_info_add.vue?vue&type=script&lang=js&"
import style0 from "./new_user_info_add.vue?vue&type=style&index=0&id=457aadf5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457aadf5",
  null
  
)

export default component.exports